export default __webpack_public_path__ + "static/jackbot-34947af23d2b23cb79330c1c1d24a88e.png";